<template>
    <div class="c-client-detail">
        <SphereNavigation color="blue" selected="client-search" :intro="false" />

        <div class="inner-content">
            <h1>{{$t('client_detail.title')}}</h1>

            <div class="search-form" v-on:keydown="keydown">
                <input class="inputfield" :class="{error:emailError}"  type="email" v-model="email" :placeholder="$t('generic.email')" />
                <div class="search-form--row">
                    <input class="inputfield" type="text" v-model="firstname" :placeholder="$t('generic.firstname')" />
                    <input class="inputfield" type="text" v-model="lastname" :placeholder="$t('generic.lastname')" />
                </div>
                <div class="btns">
                    <button class="btn-basic blue btn-search" type="button" @click.prevent="searchForm">
                        {{$t('generic.search')}}
                    </button>

                    <button class="btn-basic bordered btn-search" @click.prevent="hideEmailForm">
                        {{$t('generic.cancel')}}
                    </button>
                </div>

                <div v-if="formEmpty" class="result-error">
                    {{$t('client_detail.form_empty')}}
                </div>
            </div>
        </div>

        <Loading v-if="loading" />
    </div>
</template>

<script>
import Loading from "@/components/app/Loading.vue";
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import {isValidEmail} from "@/utils/utils.js";
import LoginMixin from "@/mixins/LoginMixin";
import {apiStore} from "@/stores/api.js";

export default {
    name : "ClientSearchForm",
    components : {
        Loading,
        SphereNavigation
    },

    mixins: [
        LoginMixin
    ],

    data() {
        return {
            firstname : "",
            lastname : "",
            email : "",
            emailError : false,
            loading : false,
            formEmpty : false,
            serverError : false
        };
    },

    methods: {
        hideEmailForm() {
            this.$router.replace({name : "client-search"});
        },

        async searchForm() {
            this.serverError = false;
            if (this.firstname === "" && this.lastname === "" && this.email === "") {
                this.formEmpty = true;
                return;
            }

            this.formEmpty = false;
            if (this.email !== "" && !isValidEmail(this.email)) {
                this.emailError = true;

            } else {
                this.emailError = false;
                this.loading = true;

                try {
                    const data = {
                        lastname: this.lastname,
                        firstname: this.firstname,
                        email: this.email,
                        shop_id: this.loggedInSales.shop_id
                    };
                    const result = await apiStore().searchErgosleepUser(data);
                    const clients = result.clients;
                    apiStore().clientSearchResult = clients;
                    this.$router.push({name : "client-search-result"});

                } catch (error) {
                    console.log("form error", error);
                    this.serverError = true;
                }

                this.loading = false;
            }
        },

        keydown(e) {
            if (e.code === "Enter") {
                this.searchForm();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-client-detail {
        height : 100%;

        .inner-content {
            padding-left: 45%;
            padding-top : 3%;
        }

        .action-btns {
            .btn-basic {
                margin-right : 1rem;
            }

            @for $i from 1 through 5 {
                & > *:nth-child(#{$i}) {
                    @include slideIntroAnimation(basicSlideIntro, 450ms, #{250ms + $i * 250ms});
                }
            }
        }

        .btn-search {
            display:block;
        }

        .result-error {
            color : $color-red;
            font-size : 1.2rem;
            margin-top : 1.2rem;
        }

        .search-form {
            @include slideIntroAnimation(basicSlideIntro, 450ms, 50ms);

            .inputfield {
                width : 49%;
                display: block;
            }

            .btns {
                display: flex;
                .btn-basic {
                    margin-right : 2rem;
                }
            }

            &--row {
                display: flex;
                justify-content: space-between;
            }
        }

        .btn-reset {
            @include slideIntroAnimation(basicSlideIntro, 450ms, 50ms);
        }

        .no-results {
            margin-bottom: 2rem;
        }

        .list--item {
            .email {
                color : #999999;
            }

            .left {
                margin-left : 1rem;
            }
            .right {
                margin-right : 1rem;
            }
        }

        .list {
            height : 55vh;
        }
    }
</style>